import request from '@/utils/request'

export function rechargeLogs (data) {
  return request({
    url: '/wechat/card/rechargeLogs',
    method: 'get',
    params: data
  })
}

export function helpAdd (data) {
  return request({
    url: '/wechat/card/helpAdd',
    method: 'post',
    data: data
  })
}

export function helpList (data) {
  return request({
    url: '/wechat/card/helpList',
    method: 'get',
    params: data
  })
}

export function updateReadStatus (data) {
  return request({
    url: '/wechat/card/updateReadStatus',
    method: 'post',
    data: data
  })
}

export function queryPackageLogs (data) {
  return request({
    url: '/wechat/card/queryPackageLogs',
    method: 'get',
    params: data
  })
}

export function bindUser (data) {
  return request({
    url: '/wechat/card/bindUser',
    method: 'post',
    data: data
  })
}

export function certByUser (data) {
  return request({
    url: '/wechat/api/card/certByUser',
    method: 'post',
    data: data
  })
}

export function getCodeSign (data) {
  return request({
    url: '/wechat/card/getCodeSign',
    method: 'post',
    data: data
  })
}

export function sendCode (data) {
  return request({
    url: '/wechat/card/sendCode',
    method: 'post',
    data: data
  })
}

// ----新版本
export function checkNo (params) {
  return request({
    url: '/wechat/api/app/checkNo',
    method: 'get',
    params: params
  })
}

export function checkCard (cn) {
  return request({
    url: '/wechat/api/card/checkCard',
    method: 'get',
    params: { cn }
  })
}

export function certInfo (data) {
  return request({
    url: '/wechat/api/card/certInfo',
    method: 'get',
    params: data
  })
}

export function cardUsage (data) {
  return request({
    url: '/wechat/api/card/cardUsage',
    method: 'get',
    params: data
  })
}

export function cardInfo (data) {
  return request({
    url: '/wechat/api/card/cardInfo',
    method: 'get',
    params: data
  })
}

export function queryIccidPackages (data) {
  return request({
    url: '/wechat/api/card/queryIccidPackages',
    method: 'get',
    params: data
  })
}

export function getOpenid (data) {
  return request({
    url: '/wechat/api/card/getOpenid',
    method: 'get',
    params: data
  })
}

export function monitor (data) {
  return request({
    url: '/wechat/api/card/monitor',
    method: 'get',
    params: data
  })
}

export function getWeApp (data) {
  return request({
    url: '/wechat/api/card/wechatApp',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card.js